import VueScrollTo from 'vue-scrollto';
const mainOptions = { container: 'body', easing: 'ease-in', offset: -60, cancelable: true, x: false, y: true};
export const scrollToForm = function (data){
  if(data)
    data.$vuetify.goTo('form', { "duration": 750, "offset": -150, "easing": "easeInQuad" })
  else 
    VueScrollTo.scrollTo('form', 750 , mainOptions);
};



// WEBPACK FOOTER //
// ./src/helpers/form-scroll-to.js